import React from "react";

const Section = () => {
    return (
        <section className="comp hero">
            <h1>يمكنك الحصول على امتيازات عبر التسجيل في موقعنا</h1>
            <p>ادخل بياناتك في  الاسفل</p>
        </section>
    )
}

export default Section